import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-block" }
const _hoisted_2 = { class: "bottom-page" }
const _hoisted_3 = { class: "light" }
const _hoisted_4 = { class: "bottom-page flex-right" }

import { watch, onBeforeUnmount } from "vue";
import PageContainer from "@/components/mobile/PageContainer.vue";
import Count from "@/components/common/Count.vue";
import { filterHash, filterNum } from "@/utils/filters";
import BlockMixins from "@/mixins/block";


export default /*@__PURE__*/_defineComponent({
  __name: 'Block',
  setup(__props) {

const {
  Loading,
  blocks,
  pages,
  pageChange,
  sizeChange,
  maxHeight,
  getNewBlocks,
} = BlockMixins();
let Timer = 0;

getNewBlocks();
watch(
  () => pages.currentPage,
  (page) => {
    if (page == 1) {
      Timer = window.setInterval(() => {
        getNewBlocks();
      }, 10000);
    } else {
      clearInterval(Timer);
    }
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  clearInterval(Timer);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, "全部区块（" + _toDisplayString(_unref(filterNum)(_unref(maxHeight))) + "个区块）", 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PageContainer, {
        onPageChange: _unref(pageChange),
        onSizeChange: _unref(sizeChange),
        currentPage: _unref(pages).currentPage,
        pageSize: _unref(pages).pageSize,
        total: _unref(pages).total
      }, null, 8, ["onPageChange", "onSizeChange", "currentPage", "pageSize", "total"])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _unref(blocks).list,
      stripe: "",
      style: {"width":"100%"},
      class: "data-table",
      "empty-text": "暂无数据",
      "element-loading-text": "拼命加载中...",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 0.8)"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "高度",
          width: "100"
        }, {
          default: _withCtx((item) => [
            _createVNode(_component_router_link, {
              to: `/blockdetail?height=${item.row.height}`,
              class: "light"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.row.height), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "blockTime",
          label: "块龄",
          width: "150"
        }, {
          default: _withCtx((item) => [
            _createVNode(Count, {
              time: item.row.blockTime
            }, null, 8, ["time"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "hash",
          label: "区块哈希",
          width: "200"
        }, {
          default: _withCtx((item) => [
            _createVNode(_component_router_link, {
              to: `/blockdetail?height=${item.row.height}`,
              class: "light"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(filterHash)(item.row.hash)), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "txCount",
          label: "数据数量",
          width: "85",
          align: "center"
        }, {
          default: _withCtx((item) => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(item.row.txCount), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _unref(Loading) && _unref(pages).currentPage != 1]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(PageContainer, {
        onPageChange: _unref(pageChange),
        onSizeChange: _unref(sizeChange),
        currentPage: _unref(pages).currentPage,
        pageSize: _unref(pages).pageSize,
        total: _unref(pages).total,
        simple: false
      }, null, 8, ["onPageChange", "onSizeChange", "currentPage", "pageSize", "total"])
    ])
  ]))
}
}

})